<template>
  <div
    v-if="!object.none"
    :class="{ disabled: !hasPermission }"
    class="text-container"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    @click="$emit('selectObject', object)"
  >
    <strong>{{ $tc(object.type, 1) }}:</strong>
    {{ objectIdentification }}
  </div>

  <div v-else class="text-container" @click="$emit('selectObject', object)">
    <strong>{{ $t("None") }}</strong>
  </div>
</template>

<script>
import { bus } from "@/main.js";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "ObjectListItem",

  mixins: [checkPermissionsMixin],

  props: {
    object: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      hover: false
    };
  },

  computed: {
    objectIdentification() {
      if (this.object.none) {
        return null;
      } else if (this.object.label) {
        return this.object.label;
      }
      return this.object.id;
    },

    objectType() {
      if (this.object.none) {
        return null;
      } else if (this.object.objectType !== undefined) {
        return this.object.objectType;
      } else {
        return this.object.type.toLowerCase();
      }
    },

    hasPermission() {
      if (this.object.none) {
        return true;
      } else if (this.objectType.includes("influence")) {
        return false;
      }

      let permissionName = this.$store.getters.getLayerPermissionName(
        this.object.layerName
      );
      if (
        permissionName === "workspace" ||
        permissionName === "fiber_terminal_box" ||
        permissionName === "workorder"
      ) {
        permissionName = this.objectType;
      }

      return this.userHasFibercloudPermission(permissionName, "show");
    }
  },

  watch: {
    hover() {
      if (this.hover && this.object.geojson) {
        bus.$emit("highlight-object-from-menu", this.object.geojson);
      } else if (this.object.isMeasurementArea) {
        bus.$emit(
          "remove-measurement-area-highlight-from-menu",
          this.object.geojson
        );
      } else {
        bus.$emit("remove-highlight-from-menu");
      }
    }
  }
};
</script>

<style scoped>
.text-container {
  width: 100%;
  text-align: left;
  padding: 5px 20px;
  font-size: 10px;
  cursor: pointer;
}
.text-container:hover {
  background: #f1f1f1;
}

.disabled {
  cursor: not-allowed;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectList/ObjectListItem.vue